import type { IHeatmapControl } from '@gem-sdk/heatmap-react';

import {
  EHeatmapType,
  useHeatmapConfigStore,
  useHeatmapDataContext,
  useHeatmapSettingContext,
} from '@gem-sdk/heatmap-react';
import { useHeatmapClickRank, useHeatmapLoadingContext } from '../../hooks';
import { BlockStack, Box, Button, Icon, Text } from '@shopify/polaris';
// import { SelectClickMode } from './ClickRank/SelectClickMode'; // WIP: re-enable once click mode is finished
import { SidebarScrollMode } from './SidebarScrollMode';
import { CancelSmallIcon } from '~/presentation/icons';
import { useFeatureFlagChecker } from '~/modules/apps';
import { SidebarClickMode } from './SidebarClickMode';
import { EHeatmapLoadingKey } from '../../types';
import { GBlockStack } from '~/presentation/ui';
import { SelectScrollType } from './ScrollRank';
import { useTranslation } from 'react-i18next';
import { SelectClickType } from './ClickRank';

export const SPACING_INSET = '300';
export type ControlSidebarProps = IHeatmapControl['Sidebar'];
export const Sidebar: ControlSidebarProps = () => {
  const mode = useHeatmapConfigStore((s) => s.mode);
  const isEmptyData = useHeatmapDataContext((s) => s.isEmptyData);
  const heatmapType = useHeatmapSettingContext((s) => s.heatmapType);
  const setIsShowSidebar = useHeatmapSettingContext((s) => s.setIsShowSidebar);
  const isLoading = useHeatmapLoadingContext((s) =>
    s.getLoadingByKey(EHeatmapLoadingKey.SNAPSHOT_DOM),
  );

  const { isEnabledHeatmapV2 } = useFeatureFlagChecker();

  const isCompareMode = mode === 'compare';

  // Initialize click rank
  useHeatmapClickRank();

  if (!isLoading && isEmptyData) {
    return <SideBarEmpty />;
  }

  return (
    <GBlockStack height="100%">
      {isEnabledHeatmapV2 ? (
        <Box padding={SPACING_INSET}>
          {heatmapType === EHeatmapType.Click && (
            <BlockStack gap={SPACING_INSET}>
              <SelectClickType />
              {/* <SelectClickMode /> WIP: re-enable once click mode is finished */}
            </BlockStack>
          )}
          {heatmapType === EHeatmapType.Scroll && <SelectScrollType />}

          {isCompareMode && (
            <Box position="absolute" insetBlockStart="300" insetInlineEnd="300">
              <Button
                icon={<Icon source={CancelSmallIcon} />}
                variant="tertiary"
                onClick={() => setIsShowSidebar(false)}
              ></Button>
            </Box>
          )}
        </Box>
      ) : (
        <>
          {heatmapType === EHeatmapType.Click && (
            <BlockStack gap={SPACING_INSET}>
              <SelectClickType />
              {/* <SelectClickMode /> WIP: re-enable once click mode is finished */}
            </BlockStack>
          )}
          {heatmapType === EHeatmapType.Scroll && (
            <Box padding={SPACING_INSET}>
              <SelectScrollType />
            </Box>
          )}
        </>
      )}

      {heatmapType === EHeatmapType.Click && <SidebarClickMode />}
      {heatmapType === EHeatmapType.Scroll && <SidebarScrollMode />}
    </GBlockStack>
  );
};

const SideBarEmpty = () => {
  const { t } = useTranslation();

  return (
    <GBlockStack height="100%" align="center">
      <Box padding={SPACING_INSET}>
        <BlockStack align="center" inlineAlign="center">
          <Text as="p" variant="bodyMd" fontWeight="medium">
            {t('Heatmap data')}
          </Text>
          <Text as="p" variant="bodyMd" tone="subdued">
            {t('No heatmap data found')}
          </Text>
        </BlockStack>
      </Box>
    </GBlockStack>
  );
};
